// src/json/utils.js
var getPointers = (dataPath) => {
  return dataPath.split("/").slice(1).map((pointer) => pointer.split("~1").join("/").split("~0").join("~"));
};
export {
  getPointers
};
//# sourceMappingURL=utils.mjs.map
